<template>
  <div>
    <v-tabs class="mt-2" background-color="grey lighten-3" v-model="journeyTabs">
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab key="initial">{{ initialJourney.name }}</v-tab>
      <v-tab key="product">{{ productJourney.name }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="journeyTabs">
      <v-tab-item key="initial">
        <groups :journey="initialJourney"></groups>
      </v-tab-item>
      <v-tab-item key="product">
        <groups :journey="productJourney"></groups>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Groups from './Groups';

export default {
  name: 'answers-container',
  components: { Groups },
  props: ['selectedProduct'],
  data: () => ({
    journeyTabs: null
  }),
  computed: {
    ...mapGetters(['JourneyTypes']),
    initialJourney: function() {
      return _.isNull(this.JourneyTypes[0].id) ? { name: 'loading...' } : this.JourneyTypes[0].journeys[0];
    },
    productJourney: function() {
      return _.isUndefined(this.JourneyTypes[1]) || _.isNull(this.selectedProduct.journey.id)
        ? { name: 'loading...' }
        : _.find(this.JourneyTypes[1].journeys, { id: this.selectedProduct.journey.id });
    }
  }
};
</script>

<style lang="scss" scoped>
.answer-list-container {
  height: calc(100vh - 150px);
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
